module.exports = __webpack_public_path__ + "media/sub4-6-4.6c956764.mp4";